// extracted by mini-css-extract-plugin
export default {"navBar":"DesktopNavBar_navBar__nIsKs","link":"DesktopNavBar_link__tWNqH","icon":"DesktopNavBar_icon__SDP4N","navTitle":"DesktopNavBar_navTitle__sFwFE"};